import React from 'react';
import styled, { css } from 'styled-components';
import { formatDatePeriod } from 'date-functions';
const sizeMap = {
  small: '12px',
  medium: '16px',
  large: '20px',
};
const StyledDatePeriod = styled.div<DatePeriodProps>`
  font-size: ${({ size = 'medium' }) => sizeMap[size]};
  ${props =>
    props.size === 'large' &&
    css`
      font-weight: 600;
    `};
`;
type DatePeriodProps = {
  startDate: Date;
  endDate: Date;
  delimiter?: string;
  size?: 'small' | 'medium' | 'large';
};
export default function DatePeriod(props: DatePeriodProps) {
  return (
    <StyledDatePeriod {...props}>
      {formatDatePeriod(props.startDate, props.endDate, props.delimiter || ' - ')}
    </StyledDatePeriod>
  );
}
